import { CdkTableModule } from "@angular/cdk/table";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { UIDirectivesModule } from "../directives";
import { TableActionsDirective } from "./actions/actions.component";
import { TableBorderIndicationDirective } from "./border-indication/border-indication.component";
import { TableCellDirective } from "./cell/cell.component";
import { TableCurrencyCellComponent } from "./cell/currency/currency-cell.component";
import { TableDateCellComponent } from "./cell/date/date-cell.component";
import { TableSortableCellComponent } from "./cell/sortable/sortable-cell.component";
import { TableDetailRowDirective } from "./detail/detail.component";
import { SortableTableDirective } from "./directives/sortable-table.directive";
import { TableExpandDirective } from "./expand/expand.component";
import { ExpandedRowCardComponent } from "./expanded-row-card/expanded-row-card.component";
import { TableIconDirective } from "./icon/icon.component";
import { TableSelectDirective } from "./select/select.component";
import { TableComponent } from "./table/table.component";
import { TableRowButtonComponent } from "./table-row-button/table-row-button.component";
import { IconModule } from "../icon/icon.module";
import { LoadingIndicatorModule } from "../loading-indicator/loading-indicator.module";

@NgModule({
	imports: [CommonModule, CdkTableModule, IconModule, UIDirectivesModule, LoadingIndicatorModule, TranslateModule],
	declarations: [
		TableComponent,
		TableCellDirective,
		TableSelectDirective,
		TableActionsDirective,
		TableIconDirective,
		TableDetailRowDirective,
		TableDateCellComponent,
		TableCurrencyCellComponent,
		TableSortableCellComponent,
		SortableTableDirective,
		TableRowButtonComponent,
		TableExpandDirective,
		TableBorderIndicationDirective,
		ExpandedRowCardComponent,
	],
	exports: [
		TableComponent,
		TableCellDirective,
		TableSelectDirective,
		TableActionsDirective,
		TableIconDirective,
		TableDetailRowDirective,
		TableDateCellComponent,
		TableCurrencyCellComponent,
		TableSortableCellComponent,
		SortableTableDirective,
		TableRowButtonComponent,
		TableExpandDirective,
		TableBorderIndicationDirective,
		ExpandedRowCardComponent,
	],
})
export class TableModule {}
